/**
 * RequestSswCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {RequestSsw} from '@/model/resource/RequestSsw'

/* TODO: review generated class */
@HttpExclude()
export class RequestSswCollection extends PageCollection<RequestSsw> {
  constructor() {
    super(RequestSsw)
  }

  queryAsPage() {
    return this.listRequestSsw()
  }

  async listRequestSsw() {
    return await Request.get(`/admin/request-ssw`, {params: this.params})
      .name('listRequestSsw')
      .as(this)
      .getResponse()
  }

  async listCsvRequestSsw() {
    return await Request.get(`/admin/request-ssw/csv`, {params: this.params})
      .name('listCsvRequestSsw')
      .as(this)
      .getResponse()
  }
}
